import React from "react";
import { BsChevronDown } from "react-icons/bs";
import { IoMdClose } from "react-icons/io";
import { components } from "react-select";
import {
	ContainerSelect2, InputContainer,
	StyledCreatableSelect2,
	StyledInput,
	StyledSelect2
} from "./style";

const DropdownIndicator = props => {
	return (
		<components.DropdownIndicator {...props}>
			<BsChevronDown />
		</components.DropdownIndicator>
	);
};

const MultiValueRemove = props => {
	return (
		<components.MultiValueRemove {...props}>
			<div className="border">
				<IoMdClose size="8px" />
			</div>
		</components.MultiValueRemove>
	);
};

const ClearIndicator = props => {
	return (
		<components.ClearIndicator {...props}>
			<div className="border" style={{ backgroundColor: "#9036F7"}}>
				<IoMdClose size="12px" />
			</div>
		</components.ClearIndicator>
	);
};

const NoOptionsMessage = props => {
	return (
		<components.NoOptionsMessage {...props}>
			Sem opções
		</components.NoOptionsMessage>
	);
};

const poppupOptions = [
	{
		name: "offset",
		options: {
			offset: [-10, 0]
		}
	}
];

export const InputField = ({
	type,
	as,
	id,
	isMulti = false,
	creatable = false,
	name,
	placeholder,
	maxLength,
	value,
	options,
	onChange,
	required,
	isInvalid,
	disabled,
	style,
	label,
	children,
	fade,
	isClearable = false,
	closeMenuOnSelect = false
}) => {
	return as !== "select2" ? (
		<InputContainer style={style} className={fade ? "fade" : ""}>
			<StyledInput
				type={type ? type : "text"}
				inputId={name}
				as={as}
				autoComplete="off"
				name={name}
				placeholder={placeholder ? placeholder : "Digite os dados"}
				maxLength={maxLength}
				value={value}
				isInvalid={isInvalid}
				onChange={onChange}
				required={required}
				disabled={disabled}
				isClearable={isClearable}
				className={
					as === "select" && value === ""
						? "placeholder"
						: as === "textarea" && isInvalid
						? "is-invalid"
						: ""
				}
			>
				{children}
			</StyledInput>
			{label && (
				<span className="label">
					{label} {required && <span className="required">*</span>}
				</span>
			)}
			{as === "select" && <div className="chevron">{<BsChevronDown />}</div>}
		</InputContainer>
	) : creatable ? (
		<ContainerSelect2>
			<StyledCreatableSelect2
				classNamePrefix="select"
				inputId={name}
				isMulti={isMulti}
				value={value}
				placeholder={placeholder}
				closeMenuOnSelect={false}
				isClearable={isClearable}
				name={name}
				options={options}
				onChange={onChange}
				isDisabled={disabled}
				formatCreateLabel={newItem => (
					<span className="select__create-option">{`Criar ${newItem}...`}</span>
				)}
				components={{
					DropdownIndicator,
					MultiValueRemove,
					ClearIndicator,
					NoOptionsMessage
				}}
			/>
			<span className="label">
				{label} {required && <span className="required">*</span>}
			</span>
		</ContainerSelect2>
	) : (
		<ContainerSelect2>
			<StyledSelect2
				classNamePrefix="select"
				inputId={name}
				isMulti={isMulti}
				value={value}
				placeholder={placeholder}
				closeMenuOnSelect={closeMenuOnSelect}
				name={name}
				options={options}
				onChange={(e) => {
					console.log('ContainerSelect2', e)
					onChange(e)
					const input = document.querySelector(`#${name}`);
					if (!!input) input.blur()
				}}
				isDisabled={disabled}
				isClearable={isClearable}
				components={{
					DropdownIndicator,
					MultiValueRemove,
					ClearIndicator,
					NoOptionsMessage
				}}
			/>
			<span className="label">
				{label} {required && <span className="required">*</span>}
			</span>
		</ContainerSelect2>
	);
};
